import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

export default defineNuxtPlugin((nuxtApp) => {
  const { public: config } = useRuntimeConfig()

  const bugsnagClient = Bugsnag.start({
    apiKey: config.bugSnagKey,
    maxBreadcrumbs: 100,
    appVersion: config.vercelGitCommitSHA || undefined,
    releaseStage: config.vercelENV || undefined,
    notifyReleaseStages: ['development', 'preview', 'production'],
    plugins: [new BugsnagPluginVue()],
  })

  Bugsnag.getPlugin('vue').installVueErrorHandler(nuxtApp.vueApp)

  return {
    provide: {
      bugsnag: bugsnagClient,
    },
  }
})
